import { cn } from "../../lib/cn";

export type SurfaceEdgeVignetteIntensity = "default" | "subtle";

const VIGNETTE_BACKGROUND: Record<SurfaceEdgeVignetteIntensity, string> = {
	/** Hexagon map SoT — readable edge darkening over bright terrain. */
	default:
		"radial-gradient(ellipse at center, rgba(0,0,0,0) 46%, rgba(0,0,0,0.18) 72%, rgba(0,0,0,0.5) 100%)",
	/**
	 * Battle ground — clearly readable on bright forest art without crushing
	 * midtones (stronger than the old `subtle` pass which was invisible in practice).
	 */
	subtle:
		"radial-gradient(ellipse at center, rgba(0,0,0,0) 42%, rgba(0,0,0,0.16) 68%, rgba(0,0,0,0.42) 100%)",
};

export interface SurfaceEdgeVignetteProps {
	className?: string;
	intensity?: SurfaceEdgeVignetteIntensity;
	/** Optional z-index when the host does not already stack the layer. */
	zIndex?: number;
	/** Test hook — battle ground confirmation, etc. */
	"data-testid"?: string;
}

/**
 * Full-bleed radial edge vignette (HexagonMap SoT).
 * Sit above photographic / painted ground, below interactive chrome.
 */
export function SurfaceEdgeVignette({
	className,
	intensity = "default",
	zIndex,
	"data-testid": dataTestId,
}: SurfaceEdgeVignetteProps) {
	return (
		<div
			className={cn("pointer-events-none absolute inset-0", className)}
			style={{
				background: VIGNETTE_BACKGROUND[intensity],
				...(zIndex != null ? { zIndex } : null),
			}}
			data-testid={dataTestId}
			aria-hidden
		/>
	);
}
